export default __webpack_public_path__ + "static/media/heating.b5dd8ab1.png";